import { FormEvent, useCallback } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { composeValidators } from '../../../../../utils/validators/compose';
import { makeIntegerValidator } from '../../../../../utils/validators/makeIntegerValidator';
import { makeRequiredValidator } from '../../../../../utils/validators/makeRequiredValidator';
import { Input as InputBase } from '../../../../input/Input';
import { makeTextControlValidate } from '../../../../input/makeTextControlValidate';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { Price } from '../../../../price/Price';
import { Typography } from '../../../../typography/Typography';
import { MIN_RATIO } from './constants';
import { Wrapper } from './styles';
import { ContentPromotionBudgetWeekProps } from './types';
const Input = makeTextControlValidate(InputBase);
const validator = composeValidators(
    makeRequiredValidator<string>(),
    makeIntegerValidator<string>(),
);

// todo: удалить компонент при раскатке content_promotion_strategy
export const ContentPromotionBudgetWeek: React.FC<ContentPromotionBudgetWeekProps> = ({
    value,
    selectedGoals,
    onChange,
    ...other
}) => {
    const t = useTranslation();
    const selectedGoalsIds = selectedGoals && Object.keys(selectedGoals);
    const minBudget =
        selectedGoalsIds &&
        selectedGoalsIds.reduce((res, id) => {
            const budget = selectedGoals[id];
            if (budget) {
                res += budget * MIN_RATIO;
            }

            return res;
        }, 0);
    const onInput = useCallback(
        (event: FormEvent<HTMLInputElement>) => {
            onChange(event.currentTarget.value);
        },
        [onChange],
    );
    const onClick = useCallback(() => {
        if (minBudget) {
            onChange(String(minBudget));
        }
    }, [minBudget, onChange]);

    return (
        <Wrapper {...other}>
            <Input
                placeholder={t('Недельный бюджет')}
                variant="outline"
                type="number"
                onInput={onInput}
                value={value ? value.toString() : undefined}
                min="0"
                step="1"
                validator={validator}
            />
            {minBudget ? (
                <Flex direction="row" mt={1}>
                    <Typography variant="body2">{t('Минимальный рекомендуемый бюджет')}</Typography>
                    <Box onClick={onClick} ml={0.5} cursor="pointer">
                        <Price
                            priceInfo={{
                                integerPart: minBudget,
                                currency: 'RUB',
                            }}
                            variant="body2"
                            weight="regular"
                            color="link"
                        />
                    </Box>
                </Flex>
            ) : null}
        </Wrapper>
    );
};
